import {
  cleanConversation,
  configWidget,
  setHandoffStatus,
} from 'actions/workflows/workflows';
import { ContextVariables } from 'api/types';
import store from 'store';

export const successfulHandoffOnSubmit = async ({
  dispatch,
  handoffSuccessVariable = '',
  updateConversation,
}: {
  dispatch: typeof store.dispatch;
  handoffSuccessVariable?: string;
  updateConversation: (context: ContextVariables) => Promise<void>;
}) => {
  if (!handoffSuccessVariable) return;

  await updateConversation({ [handoffSuccessVariable]: true });
  await dispatch(setHandoffStatus('not_started'));
  await dispatch(cleanConversation());
  await dispatch(configWidget());
};
